export default "__VITE_ASSET__BCkX8LMs__"